import { InferType, object, string } from 'yup';

import {
  MAX_EMAIL_LENGTH,
  withPasswordMaxLengthValidation,
} from '@/shared/config';

export const signInSchema = object({
  email: string().email().required().max(MAX_EMAIL_LENGTH),
  password: withPasswordMaxLengthValidation(string().required()),
});

export type SignInFormPayload = InferType<typeof signInSchema>;
